import React from 'react';
import { FormItemProps } from 'antd';
import { I18n } from '@aws-amplify/core';
import * as S from './styles';

interface CustomFormItemProps extends FormItemProps {
	requiredMessage?: string;
}

export default function FormItem({
	label = '',
	required = false,
	requiredMessage = '',
	labelCol,
	...props
}: Readonly<CustomFormItemProps>): JSX.Element {
	return (
		<S.CustomFormItem
			{...props}
			$required={required}
			labelCol={labelCol}
			label={I18n.get(label)}
			rules={props.rules || [{ required, message: I18n.get(requiredMessage) }]}
		/>
	);
}
